<style lang="sass">
  body.pinhigh-select-open
    height: 100vh
    width: 100vw
    overflow: hidden
</style>
<style scoped lang="sass">
.pinhigh-select-display-wrapper
  display: inline-block
  &.pinhigh-select-display-block
    display: block
  &.pinhigh-select-display-size-small
    .pinhigh-select-display
      font-size: 0.75rem
      line-height: 0.75rem;
      padding: 0.25rem 0.5rem
  .pinhigh-select-display
    display: flex
    justify-content: space-between
    align-items: center
    box-sizing: border-box
    background-color: var(--light-gray)
    color: var(--dark-gray)
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 300
    padding: 0.5rem
    border: 1px solid var(--border-gray)
    border-radius: 0.3rem
    cursor: pointer
    >i
      margin-left: 0.5rem
      display: inline-block
      background-repeat: no-repeat
      height: 1rem
      width: 1rem
      background-position: center
      background-size: contain
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAQCAYAAAAI0W+oAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAM9JREFUeNqs1NENgjAQBuACLzwygt2AFXACRpANdAM3YAQ6hk82TiAbFDdwBP8mmFSg3rX0koO2XO8rCaEQiKY51lLKcprMWyQM9D2gb2X75pj0WHsiDcanhIjtZea+5wLizXneYv7CCcYEyOAslTkualE37HmzDcTGw0IX5JgC8yBK6/s1mwsq3DSyXhR1KFI7kc4OMqcwGqOQHygW4yArKBTjIpsQFwtBvBCFfb9MLvIXIjARgpAQEyMRFkRgLIQNeTA2Ev0vQ7ah+z4CDABsYHVR25ZunAAAAABJRU5ErkJggg==)
.pinhigh-select-wrapper
  position: fixed
  display: flex
  justify-content: center
  align-items: center
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0,0,0,0.5)
  z-index: 5
  .pinhigh-select
    width: 80%
    max-height: 80%
    overflow: auto
    background-color: white
    user-select: none
    border-radius: 0.5rem
    .pinhigh-select-option
      border-bottom: 1px solid #e6e7e8
      background-color: white
      padding: 0.5rem
      cursor: pointer
      &.pinhigh-select-selected, &:active, &:focus, &:hover
        background-color: blue
        color: white
      &:last-child
        border-bottom: none
</style>
<template>
  <div class="pinhigh-select-display-wrapper" :class="{'pinhigh-select-display-block': block, 'pinhigh-select-display-size-small': size === 'small'}">
    <div class="pinhigh-select-display" @click.prevent="open">
      <slot name="label" :option="valueOption">
        <span>{{valueLabel || ' '}}</span>
      </slot>
      <i></i>
    </div>
    <transition appear name="fade-quickly">
      <div class="pinhigh-select-wrapper" v-if="opened" @click.self.prevent="close">
        <div class="pinhigh-select">
          <div
              v-for="option in options"
              @click="select(option)"
              class="pinhigh-select-option"
              :class="{'pinhigh-select-selected': optionValue(option) === value}"
              >
                <slot name="label" :option="option">{{optionLabel(option)}}</slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'PinhighSelect',
  props: {
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    value: {
      type: [Number, String]
    },
    onSelect: {
      type: Function
    },
    disabled: {
      type: [Boolean, String, Number]
    },
    block: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      opened: false
    };
  },
  mounted() {
    document.querySelector('body').classList.add('pinhigh-select-open');
  },
  destroyed() {
    document.querySelector('body').classList.remove('pinhigh-select-open');
  },
  computed: {
    valueOption() {
      return this.options.find(option => this.optionValue(option) === this.value);
    },
    valueLabel() {
      return this.value ? this.optionLabel((this.valueOption || {})) : null;
    }
  },
  methods: {
    optionValue(option) {
      return typeof(option) === 'object' ? option.value : option;
    },
    optionLabel(option) {
      return typeof(option) === 'object' ? option.label : option;
    },
    open() {
      if (!this.disabled) {
        this.opened = true;
      }
    },
    close() {
      this.opened = false;
    },
    select(option) {
      this.$emit('input', this.optionValue(option));
      if (this.onSelect) {
        this.onSelect(this.optionValue(option));
      }
      this.close();
    }
  }
};
</script>
